/**
 * @license Copyright (c) 2003-2018, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * @module utils/dom/iswindow
 */

/**
 * Checks if the object is a native DOM Window.
 *
 * @param {*} obj
 * @returns {Boolean}
 */
export default function isWindow( obj ) {
	return Object.prototype.toString.apply( obj ) == '[object Window]';
}



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/dom/iswindow.js
// module id = null
// module chunks = 